import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/admin/login/error.tsx");
